import { List, Spin } from "antd";
import Image from "next/image";
import { useContext, useEffect, useState } from "react";

import CollectionContext from "modules/Collection/context";
import getFallbackImage from "shared/utils/getFallbackImage";

import { CheckboxWrapper, Checkbox, Link, ListItem } from "./styles";

const Collection = ({ item, classItem, newCollection }) => {
  const { entityType, setItemCollections, removeItemCollections } =
    useContext(CollectionContext);

  const mockEmpty = getFallbackImage();

  const [isChecked, setIsChecked] = useState(false);
  const [failedLoadMainImg, setFailedLoadMainImg] = useState(false);

  const collectionItems = null;
  const thumb = item.resources[0]?.relation.image_thumbnail;

  const newCollect =
    newCollection?.name === item.name &&
    newCollection?.description === item.description;

  const onChangeCheckbox = (checked, collectionId) => {
    if (checked) {
      setItemCollections({
        className: classItem,
        item: entityType?.id,
        collections: collectionId,
      });
    } else {
      removeItemCollections({
        className: classItem,
        item: entityType?.id,
        collections: collectionId,
      });
    }
  };

  useEffect(() => {
    const itemAddedInCollection = item.resources.filter(
      (resource) =>
        resource?.relation.id === entityType.id &&
        resource?.relation.className === classItem,
    );

    if (itemAddedInCollection.length > 0) setIsChecked(true);
  }, [item, classItem, entityType]);

  return (
    <>
      {collectionItems ? (
        <Spin />
      ) : (
        <ListItem key={item.id} className="ant-checkbox">
          <List.Item.Meta
            avatar={
              <Link href={`/collections/${item.id}`} className="ant-checkbox">
                <a>
                  <Image
                    alt="thumb"
                    width={115}
                    height={70}
                    className="image_thumb"
                    onError={() => setFailedLoadMainImg(true)}
                    src={failedLoadMainImg ? mockEmpty : thumb || mockEmpty}
                  />
                </a>
              </Link>
            }
            title={
              <Link href={`/collections/${item.id}`} className="ant-checkbox">
                <a>{item.name}</a>
              </Link>
            }
            description={
              <CheckboxWrapper
                className="ant-checkbox"
                onClick={() => {
                  onChangeCheckbox(!isChecked, item.id);
                  setIsChecked(!isChecked);
                }}
              >
                <span>{item.resources?.length} itens</span>

                <Checkbox
                  checked={isChecked || newCollect}
                  data-testid="checkbox-relation-item"
                />
              </CheckboxWrapper>
            }
          />
        </ListItem>
      )}
    </>
  );
};

export default Collection;
